import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface TooltipProps {
  children?: any;
}

export const TooltipTestId = 'details-tooltip';
export const DatasourceTooltipTestId = 'datasource-details-tooltip';


export function Tooltip(props: TooltipProps) {
  return (
    <div className={DetailsTooltipStyles.DetailsTooltip} data-tb-test-id={TooltipTestId}>
      {props.children}
    </div>
  );
}

export function DatasourceTooltip(props: TooltipProps) {
  return (
    <div className={DetailsTooltipStyles.DatasourceDetailsTooltip} data-tb-test-id={DatasourceTooltipTestId}>
      {props.children}
    </div>
  );
}
